export default __webpack_public_path__ + "static/media/kick-guest.9a52ee47.svg";